/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Tomáš Burian (burian@cadwork.cz)
 *
 */

import RenderDocument from "App/render_document";
import FileAnimationControls from "App/view/controls/file_animation_controls";
import View from "App/view/view";
import CameraStereo from "App/view/cameras/camera_stereo";
import {EViewControls} from "js_interface/src/modules/view_controls/scene_view_controls_enums";

export default
class FileAnimationControlsStereo extends FileAnimationControls {
    constructor(aDocument: RenderDocument, aView: View) {
        super(aDocument, aView);

        // replace the orthographic camera created by the WalkControls->ViewControls
        this._camera = new CameraStereo(this._view);
        this._initCameraParams();
    }

    public getControlsType(): EViewControls {
        return EViewControls.FILE_ANIMATION_STEREO;
    }
}
